import { render, staticRenderFns } from "./PetitionDialogContent.vue?vue&type=template&id=2f8cf0de&scoped=true"
import script from "./PetitionDialogContent.vue?vue&type=script&lang=ts"
export * from "./PetitionDialogContent.vue?vue&type=script&lang=ts"
import style0 from "./PetitionDialogContent.vue?vue&type=style&index=0&id=2f8cf0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8cf0de",
  null
  
)

export default component.exports